import { escapeJsx } from '@cli-utils/text.js'
import { renderBuildLoadingSkeletonSourceGeneratedFunctionTemplate } from '@next-adapter/templates/renderers/generators/emitted-helpers.js'

export function buildLoadingSkeletonSource(componentName: string, label: string): string {
  return renderBuildLoadingSkeletonSourceGeneratedFunctionTemplate({
    componentName: componentName,
    escapeJsx: escapeJsx(label)
  })
}
